























import VueOptions from '@utils/VueOptions'
import EventService from '@services/EventService'
import CalendarService from '@services/CalendarService'
import LoadingIndicator from '@components/LoadingIndicator'
import EventResourceList from './EventResourceList'
import AddToCartTriggerModal from '@triggers/CheckoutWizard/AddToCartTriggerModal'
import RemoveFromCartTriggerModal from '@triggers/CheckoutWizard/RemoveFromCartTriggerModal'
import ExportFeedCSVTriggerModal from '@triggers/Campaign/ExportFeedCSVTriggerModal'
import ExportRecommendationsDeckTriggerModal from '@triggers/Campaign/ExportRecommendationsDeckTriggerModal'
import RecommendToCampaignsTriggerModal from '@triggers/Campaign/RecommendToCampaignsTriggerModal'
import UnrecommendToCampaignTriggerModal from '@triggers/Campaign/UnrecommendToCampaignTriggerModal'

settings =
  name: "EventFeed"
  components: {
    LoadingIndicator,
    EventResourceList,
    AddToCartTriggerModal,
    RemoveFromCartTriggerModal,
    ExportFeedCSVTriggerModal,
    ExportRecommendationsDeckTriggerModal,
    RecommendToCampaignsTriggerModal,
    UnrecommendToCampaignTriggerModal
  }
  resources:
    scanner:
      resourceName: 'scanner'
      slug: 'campaigns/:campaignId/scanner/edit'
    audience_listings:
      resourceName: 'audience_listings'
      slug: 'campaigns/:campaignId/scanner/audience_listings'
      infinityScroll: true
    shopping_cart:
      resourceName: 'shopping_cart'
      slug: 'campaigns/:campaignId/shopping_cart'
    line_items:
      resourceName: "shopping_cart_line_item"
      slug: "campaigns/:campaignId/shopping_cart_line_items"
      params:
        limit: 9999
    event_requests:
      resourceName: 'event_request'
      slug: 'event_requests'
      fetch: false
    campaign_feed:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'
      fetch: false
    activation_plans:
      resourceName: 'activation_plan'
      slug: 'campaigns/:campaignId/activation_plans'
      fetch: false
    nearby_pois:
      resourceName: 'nearby_poi'
      slug: 'nearby_pois'
      fetch: false

  vue:
    props: ['campaign']

    data: ->
      bulkActionResultItems: []
      selectedType: ''

    computed:
      campaignId: -> @campaign.id
      cartId: -> @shopping_cart?.id
      isDetailsPage: -> @$route.name is 'EventFeedDetails'

      audienceListingsPerSegment: ->
        return [] unless @audience_listings
        listings = {}
        for listing in @audience_listings
          for spaceKey, space of listing.spaces
            l = JSON.parse(JSON.stringify(listing))
            l.segment = space.segment
            key = "#{l.id}:#{space.type}:#{space.segment}"
            l.calendar_events = CalendarService.normalizeEvents l.calendar_dates
            creative = @campaignCreativeForSpace space, @campaign.creatives
            listings[key] = l if creative

        Object.values listings

      listActions: ->
        {
          fetchResource: @fetchResource,
          fetchActivationPlans: @fetchActivationPlans,
          fetchPOIs: @fetchPOIs,
          exportFeedCSVTrigger: @exportFeedCSVTrigger,
          exportRecommendationsDeckTrigger: @exportRecommendationsDeckTrigger,
          addAllToCartTrigger: @addAllToCartTrigger,
          pokeNewRecommendationsTrigger: @pokeNewRecommendationsTrigger
        }

      listItemActions: ->
        {
          hiAddToCartTrigger: @hiAddToCartTrigger,
          removeFromCartTrigger: @removeFromCartTrigger,
          requestForMoreInfoTrigger: @requestForMoreInfoTrigger,
          favoriteEventTrigger: @favoriteEventTrigger,
          unfavoriteEventTrigger: @unfavoriteEventTrigger,
          recommendEventTrigger: @recommendEventTrigger,
          recommendToCampaignsTrigger: @recommendToCampaignsTrigger,
          unrecommendToCampaignTrigger: @unrecommendToCampaignTrigger
        }

      optionsForResourceList: ->
        {
          title: @prime.scanner.name,
          hideRowSize: true,
          lineItems: @line_items,
          scanner: @prime.scanner,
          campaign: @campaign,
          cart: @shopping_cart,
          activationPlans: @activation_plans,
        }

    created: ->
      @registerEventHandlers()

    mounted: ->
      @clearDataForResourceKey('audience_listings')

    beforeDestroy: ->
      @unregisterEventHandlers()

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      fetchActivationPlans: (audienceListingIds, target) ->
        @fetch 'activation_plans', { campaign_id: @campaign.id, audience_listing_ids: audienceListingIds, target }

      fetchPOIs: (poi_ids, audience_listing_ids) ->
        @fetch 'nearby_pois', { poi_ids, audience_listing_ids, campaign_id: @campaign.id }

      registerEventHandlers: ->
        @unregisterEventHandlers()
        EventService.$on('progress-bar-completed', @onProgressBarCompleted)
      unregisterEventHandlers: ->
        EventService.$off('progress-bar-completed', @onProgressBarCompleted)
      onProgressBarCompleted: (bar) ->
        @fetch('shopping_cart') if bar.key.includes('add_target_events')

      hiAddToCartTrigger: (audience_listing_id, segment, target) ->
        payload = { audience_listing_id, segment, target }
        @triggerResource 'line_items', 'add_to_cart', payload
      onLineItemsAddToCart: ->
        @fetch 'shopping_cart'

      removeFromCartTrigger: (audienceListing) ->
        { id, segment } = audienceListing
        @triggerResource 'line_items', 'remove_listing_from_cart', { audience_listing_id: id, segment }
      onLineItemsRemoveListingFromCart: ->

      addAllToCartTrigger: (target) ->
        payload = { target }
        @triggerResource 'shopping_cart', 'add_all_to_cart', payload
      onShoppingCartAddAllToCart: ->
        @fetchProgressBars()

      requestForMoreInfoTrigger: (event) ->
        @triggerResource 'event_requests', 'request_for_more_info', { event_id: event.id }
      onEventRequestsRequestForMoreInfo: ->
        @showFlash({ info: "Thanks for you interest. We'll let the organizer know that you want more info." })

      eventForLineItem: (lineItem) -> @ctxEvent lineItem

      hasProductSamplingLineItem: (lineItems) ->
        !!lineItems.find((lineItem) =>
          spaceType = @ctxEvent(lineItem)?.spaces?[lineItem.space_name]?.type
          'product_sampling' is spaceType
        )

      exportFeedCSVTrigger: (target_filters={}) ->
        payloadOptions = { target_filters }
        @$refs.exportFeedCSVTrigger.fire(payloadOptions)
      onCampaignFeedDownloadTargetEvents: (target={}) ->
        @$refs.exportFeedCSVTrigger.close()

      exportRecommendationsDeckTrigger: ->
        @$refs.exportRecommendationsDeckTrigger.fire()
      onCampaignFeedExportRecommendationsDeck: ->
        @$refs.exportRecommendationsDeckTrigger.close()

      favoriteEventTrigger: (event) ->
        @triggerResource 'campaign_feed', 'favorite_event', { event_id: event.id }
      unfavoriteEventTrigger: (event) ->
        @triggerResource 'campaign_feed', 'unfavorite_event', { event_id: event.id }

      recommendEventTrigger: (event) ->
        @triggerResource 'campaign_feed', 'recommend_event', { campaign_ids: [@campaign.id], event_id: event.id }

      recommendToCampaignsTrigger: (event) ->
        payloadOptions = { event_id: event.id }
        modalOptions = { event }
        @$refs.recommendToCampaignsTrigger.fire(payloadOptions, modalOptions)
      onCampaignFeedRecommendEvent: ->
        @$refs.recommendToCampaignsTrigger.close()

      unrecommendToCampaignTrigger: (event) ->
        payloadOptions = { event_id: event.id }
        modalOptions = { event }
        @$refs.unrecommendToCampaignTrigger.fire(payloadOptions, modalOptions)
      onCampaignFeedUnrecommendEvent: ->
        @$refs.unrecommendToCampaignTrigger.close()

      pokeNewRecommendationsTrigger: ->
        @triggerResource 'campaign_feed', 'poke_new_recommendations'

export default VueOptions.vue settings
